"use client";

import { useRouter } from "next/navigation";
import { useCallback, useContext } from "react";
import AllGamesNavigationContext from "./AllGamesNavigationContext";

const useAllGamesNavigate = () => {
  const navigate = useContext(AllGamesNavigationContext);
  const router = useRouter();

  const fallback = useCallback(
    (href: string) => router.push(href, { scroll: false }),
    [router],
  );

  return navigate ?? fallback;
};

export default useAllGamesNavigate;
